import React from "react";
import QRCodeGenerator from "./qr-generator";

function App() {
  return <QRCodeGenerator />;
}

export default App;

